module.exports = __webpack_public_path__ + "static/media/jenny_detouree_chemiseblanche.c8cb3fba.webp";